import { enqueueSnackbar } from 'notistack';

/**
 * Handles success response from API and shows notification
 * @param response - API response object with message
 * @param defaultMessage - Fallback message if response doesn't contain one
 */
export const handleSuccessNotification = (response: any, defaultMessage = 'Operation successful') => {
  const message = response?.message || defaultMessage;
  enqueueSnackbar(message, {
    variant: 'success',
    autoHideDuration: 3000,
    preventDuplicate: true,
  });
};

/**
 * Handles error response from API and shows notification
 * Supports both string messages and array of validation errors
 * @param error - Error object or API error response
 * @param defaultMessage - Fallback message if error doesn't contain one
 */
export const handleErrorNotification = (error: any, defaultMessage = 'An error occurred') => {
  let message = defaultMessage;

  if (error?.response?.data) {
    const data = error.response.data;
    if (Array.isArray(data.message)) {
      // Handle array of validation errors
      message = data.message.join('\n');
    } else if (data.message) {
      message = data.message;
    } else if (data.error) {
      message = data.error;
    }
  } else if (error?.message) {
    // Handle Error objects
    message = error.message;
  } else if (typeof error === 'string') {
    message = error;
  }

  enqueueSnackbar(message, {
    variant: 'error',
    autoHideDuration: 5000,
    preventDuplicate: true,
  });
};

/**
 * Common mutation callbacks for React Query
 * Usage in useMutation:
 * const mutation = useMutation({
 *   mutationFn: apiCall,
 *   ...getMutationCallbacks('Success message', 'Error message'),
 * });
 */
export const getMutationCallbacks = (successMessage?: string, errorMessage?: string) => ({
  onSuccess: (data: any) => {
    handleSuccessNotification(data, successMessage);
  },
  onError: (error: any) => {
    handleErrorNotification(error, errorMessage);
  },
});
